import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '../tools/tools.module';

import { ReleasesComponent } from './pages/releases.component';
import { ReleasesRoutingModule } from './releases-routing.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
@NgModule({
  declarations: [ReleasesComponent],
  imports: [CommonModule, ToolsModule, ReleasesRoutingModule, MaterialModule],
})
export class ReleasesModule {}
